import React, { useState, useEffect } from "react";
import { Image, Keyboard, Text, View } from "react-native";
import {
  CreateResponsiveStyle,
  DEVICE_SIZES,
  useDeviceSize,
} from "rn-responsive-styles";
import { AppColors } from "../../utility/AppColors";
import { AppFontStyle } from "../../styles/AppFontStyle";
import Separator from "../Separator";
import CommonTextInputWeb from "../../common/CommonTextInputWeb";
import { TouchableOpacity } from "react-native";
import { AppImages } from "../../utility/AppImages";
import { toast } from "react-toastify";
import { searchUsers } from "../../services/eventsAPI";
import BlockAndReportComponent from "./BlockAndReportComponent";
import UnblockComponent from "./UnblockComponent";
import AccountTabSkeleton from "../skeleton-components/AccountTabSkeleton";
import { useUserProfile } from "../../hooks/useUserProfile";

const BlockReportTabComponent = ({ accessToken }) => {
  const { userProfileData, loading: profileLoading, refetch } = useUserProfile(accessToken);
  const styles = useStyles();
  const deviceSize = useDeviceSize();
  const [updates, setUpdates] = useState({
    blockedUsers: [],
  });
  const [accountDetails, setAccountDetails] = useState({
    blockedUsers: [],
  });
  const [searchText, setSearchText] = useState("");
  const [filteredSuggestions, setFilteredSuggestions] = useState([]);
  const [showSuggestions, setShowSuggestions] = useState(true);
  const [blockedUsers, setBlockedUsers] = useState([]);
  const [selectedUser, setSelectedUser] = useState(null);
  const [isLoading, setIsLoading] = useState(false);

  useEffect(() => {
    if (userProfileData) {
      setAccountDetails({
        blockedUsers: userProfileData.blockedUsers || [],
      });
      setBlockedUsers(userProfileData.blockedUsers || []);
      setUpdates({
        blockedUsers: userProfileData.blockedUsers || [],
      });
    }
  }, [userProfileData]);

  if (profileLoading) {
    return <AccountTabSkeleton />;
  }

  const handleSearchChange = async (text) => {
    setSearchText(text);
    if (text.length > 0) {
      const query = text;
      setIsLoading(true);
      try {
        await callSearchAPI({
          bodyParams: { query, currentUsername: userProfileData?.userID || "" },
          responseSuccess: (response) => {
            setFilteredSuggestions(response.results);
            setShowSuggestions(true);
          },
        });
      } catch (error) {
        console.error("Unexpected error during search:", error);
        setFilteredSuggestions([]);
      } finally {
        setIsLoading(false);
      }
      // const filtered = blockedUsersData.filter((user) =>
      //   user.toLowerCase().includes(text.toLowerCase())
      // );
      // setFilteredSuggestions(filtered);
      // setShowSuggestions(true);
    } else {
      setShowSuggestions(false);
      setIsLoading(false);
    }
  };

  const handleSuggestionSelect = (suggestion) => {
    if (!blockedUsers.includes(suggestion)) {
      const updatedBlockedUsers = [...blockedUsers, suggestion];
      setBlockedUsers(updatedBlockedUsers);
    }
    setSearchText(suggestion);
    setShowSuggestions(false);
    Keyboard.dismiss();
  };

  const callSearchAPI = async ({ bodyParams, responseSuccess }) => {
    try {
      const data = await searchUsers(bodyParams);

      if (data.statusCode === 200) {
        responseSuccess(data.body);
      } else {
        toast.error(data.body.error || "An error occurred");
      }
    } catch (error) {
      toast.error(error.message);
    }
  };
  const toggleMenu = (user) => {
    setSelectedUser((prev) => (prev === user ? null : user)); // Toggle menu for the user
  };

  return (
    <View
      style={{
        backgroundColor: AppColors.purple_453B50,
        borderRadius: 10,
        padding: 20,
      }}
    >
      <View
        style={{
          paddingTop:
            deviceSize === DEVICE_SIZES.SM || deviceSize === DEVICE_SIZES.XS
              ? 0
              : 30,
          paddingBottom:
            deviceSize === DEVICE_SIZES.SM || deviceSize === DEVICE_SIZES.XS
              ? 20
              : 50,
        }}
      >
        <Text style={[AppFontStyle.BOLD_ANYBODY_20, {}]}>
          Block/Report Users
        </Text>
        <Separator
          color={AppColors.green_4CD964}
          height={2}
          marginTop={5}
          marginBottom={0}
          width={"40"}
          marginHorizontal={0}
        />
      </View>
      <View>
        <View style={styles.accountData}>
          <Text style={[AppFontStyle.BOLD_ANYBODY_14, styles.accountText]}>
            Block users
          </Text>
          <View style={styles.searchContainer}>
            <CommonTextInputWeb
              placeholder="Username or Email"
              mainStyle={[
                styles.accountInputStyle,
                {
                  padding: 0,
                  opacity: 0.5,
                },
              ]}
              inputStyle={[AppFontStyle.REGULAR_ANYBODY_14, {}]}
              prefixIconVisibility={false}
              onChangeText={handleSearchChange}
              isPassword={false}
              value={searchText}
              onSubmitEditing={() => {
                Keyboard.dismiss();
              }}
              editable={true}
              autoCapitalize="none"
              maxLength={50}
            />
            <TouchableOpacity onPress={() => {}}>
              <Image
                source={AppImages.icSearchWhite}
                style={{
                  width: 17,
                  height: 18,
                  position: "absolute",
                  right: 15,
                  marginTop: 3,
                  bottom: -10,
                }}
              />
            </TouchableOpacity>
          </View>
        </View>
        {showSuggestions && (
          <View
            style={{
              flexDirection: "row",
              flexWrap: "wrap",
              gap: 10,
              marginLeft:
                deviceSize === DEVICE_SIZES.SM || deviceSize === DEVICE_SIZES.XS
                  ? 0
                  : 20,
              minHeight: 300,
            }}
          >
            {/* {filteredSuggestions.length === 0 ? (
              <Text style={AppFontStyle.REGULAR_ANYBODY_14}>
                No users found for "{searchText}". Try a different search term.
              </Text>
            ) : ( */}
            {filteredSuggestions.map((user) => (
              <BlockAndReportComponent
                user={user}
                selectedUser={selectedUser}
                toggleMenu={toggleMenu}
                accessToken={accessToken}
                userProfileData={userProfileData}
                blockedUsers={userProfileData?.blockedUsers || []}
                refetchProfile={refetch}
                setSearchText={setSearchText}
                setFilteredSuggestions={setFilteredSuggestions}
              />
            ))}
            {/* )} */}
          </View>
        )}
        {userProfileData?.blockedUserDetails.length > 0 && (
          <View>
            <Text
              style={[
                AppFontStyle.BOLD_ANYBODY_20,
                {
                  color: AppColors.white,
                  marginBottom: 20,
                  marginTop:
                    deviceSize === DEVICE_SIZES.XS ||
                    deviceSize === DEVICE_SIZES.SM
                      ? 60
                      : 20,
                },
              ]}
            >
              Blocked Users
            </Text>

            <View
              style={{
                flexDirection: "row",
                flexWrap: "wrap",
                gap: 10,
                marginLeft:
                  deviceSize === DEVICE_SIZES.SM ||
                  deviceSize === DEVICE_SIZES.XS
                    ? 0
                    : 20,
                minHeight: 130,
                zIndex: 1,
              }}
            >
              {userProfileData?.blockedUserDetails.map((user) => (
                <UnblockComponent
                  user={user}
                  selectedUser={selectedUser}
                  toggleMenu={toggleMenu}
                  accessToken={accessToken}
                  userProfileData={userProfileData}
                  blockedUsers={userProfileData?.blockedUsers || []}
                  refetchProfile={refetch}
                />
              ))}
            </View>
            {/* <View
            style={{
              flexDirection: "row",
              flexWrap: "wrap",
              gap: 10,
              marginLeft:
                deviceSize === DEVICE_SIZES.SM || deviceSize === DEVICE_SIZES.XS
                  ? 0
                  : 20,
              minHeight: 50,
            }}
          >
            <View
              style={{
                width: 60,
                alignItems: "center",
                justifyContent: "center",
              }}
            >
              <ImageComponent
                url={AppImages.icRightIcon}
                style={{
                  resizeMode: "contain",
                  width: 25,
                  height: 19,
                }}
              />
            </View>
            {userProfileData?.blockedUserDetails.map((user) => (
              <UserBlockListing user={user} />
            ))}
          </View> */}
          </View>
        )}
        {isLoading && <ShowLoader showIndicater={isLoading} />}
      </View>
      {/* <View
        style={{
          flexDirection: "row",
          justifyContent:
            deviceSize === DEVICE_SIZES.SM || deviceSize === DEVICE_SIZES.XS
              ? "center"
              : "flex-end",
          marginTop: 100,
        }}
      >
        <CommonButton
          title="Save"
          onTap={async () => {
            await callUpdateEventAPI();
          }}
          buttonStyle={[
            styles.btnStyle,
            {
              paddingHorizontal: 20,
            },
          ]}
          textStyle={[AppFontStyle.BOLD_ANYBODY_12, {}]}
        />
      </View> */}
    </View>
  );
};

export default BlockReportTabComponent;

const useStyles = CreateResponsiveStyle(
  {
    searchContainer: {
      flexDirection: "row",
      alignItems: "center",
      backgroundColor: AppColors.black,
      borderRadius: 10,
      width: 284,
      height: 40,
    },
    accountInputStyle: {
      backgroundColor: AppColors.black,
      borderRadius: 10,
      width: 284,
      height: 40,
    },
    accountData: {
      flexDirection: "row",
      gap: 20,
      alignItems: "center",
      marginBottom: 20,
    },
    accountText: {
      width: 87,
      textAlign: "right",
    },
    btnStyle: {
      paddingVertical: 10,
      paddingHorizontal: 10,
      backgroundColor: AppColors.appViolentColor_6D08C3,
      shadowOpacity: 0,
      borderRadius: 10,
      alignSelf: "flex-start",
      marginTop: 4,
      boxShadow: "0px 4px 4px 0px rgba(0, 0, 0, 0.25)",
    },
    playerImg: {
      height: 49,
      width: 49,
      marginTop: 10,
      marginBottom: 5,
    },
  },
  {
    [DEVICE_SIZES.MD]: {},
    [DEVICE_SIZES.LG]: {},
    [DEVICE_SIZES.SM]: {
      searchContainer: {
        flex: 1,
        width: "100%",
      },
      accountText: {
        width: "100%",
        textAlign: "left",
      },
      accountInputStyle: {
        flex: 1,
        width: "100%",
      },
      accountData: {
        flexDirection: "column",
        gap: 10,
      },
    },
    [DEVICE_SIZES.XS]: {
      searchContainer: {
        flex: 1,
        width: "100%",
      },
      accountText: {
        width: "100%",
        textAlign: "left",
      },
      accountInputStyle: {
        flex: 1,
        width: "100%",
      },
      accountData: {
        flexDirection: "column",
        gap: 10,
      },
    },
  }
);
